// extracted by mini-css-extract-plugin
module.exports = {"content":"Popover_content__EEbqw","contentShadow":"Popover_contentShadow__Df71T"};